/* unplugin-vue-components disabled */import { render } from "./public_bottom.vue?vue&type=template&id=9dceb92a&scoped=true"
import script from "./public_bottom.vue?vue&type=script&lang=js"
export * from "./public_bottom.vue?vue&type=script&lang=js"

import "./public_bottom.vue?vue&type=style&index=0&id=9dceb92a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dceb92a"]])

export default __exports__